import CustomMultiple from './Index.vue'
CustomMultiple.install = function(Vue) {
  Vue.component(CustomMultiple.name, CustomMultiple)
}

export default CustomMultiple
